import { Injectable } from '@angular/core';

import { Query, gql } from 'apollo-angular';

import { MiniTeaserBanner, QueryMiniTeaserBannersArgs } from '@hdms/shared/common-types';

interface MiniTeaserBannersResponse {
  miniTeaserBanners: MiniTeaserBanner[];
}

@Injectable({
  providedIn: 'root'
})
export class MiniTeaserBannersGqlService extends Query<MiniTeaserBannersResponse, QueryMiniTeaserBannersArgs> {
  override document = gql`
    query MiniTeaserBanners($categoryId: ID, $localization: LocalizationInput!) {
      miniTeaserBanners(categoryId: $categoryId, localization: $localization) {
        id
        headline
        body
        imageUri
        imageAlt
        linkUri
        webAnalyticsData {
          trackName
          trackId
          trackCreative
        }
      }
    }
  `;
}
